import { firestore, storage, auth } from '../firebase';

export const getApps = async () => firestore.collection('applications').get()
  .then(async (snapshot) => {
    let data = [];
    snapshot.forEach(doc => {
      data.push({ ...doc.data(), id: doc.id });
    })
    const userRef = firestore.collection('users').doc(auth.currentUser.uid);
    console.log('APPS', data);
    await userRef.get()
      .then(doc => {
        if (doc.exists) {
          const { apps = [] } = doc.data();
          const filteredApps = data.filter(item => apps.includes(item.id));
          if (!!filteredApps[0]) data = filteredApps;
        }
      })

    return data;
  });

export const getFile = urlReference => storage.refFromURL(urlReference)
  .getDownloadURL()
  .then(url => url);

export const getAppById = async id => {
  const docRef = firestore.collection('applications').doc(id);
  return docRef.get()
    .then(doc => doc ? doc.data() : null);
    
}
